var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrontpageStep4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124.241,
    height: 122.221,
    viewBox: "0 0 124.241 122.221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(-1375 -1032.127)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 56.337,
    cy: 56.337,
    rx: 56.337,
    ry: 56.337,
    transform: "translate(1386.567 1041.674)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(1429.509 1032.127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(1.986 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M268.351,791.491a6.164,6.164,0,0,0,2.944,2.5,5.307,5.307,0,0,0-3.414-6.332A6.163,6.163,0,0,0,268.351,791.491Z",
    transform: "translate(-256.677 -726.143)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M240.09,819.5a6.163,6.163,0,0,1,2.358,3.058,5.307,5.307,0,0,1-6.164-3.709A6.163,6.163,0,0,1,240.09,819.5Z",
    transform: "translate(-227.768 -754.726)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M303.98,518.983c2.667-7.014,3.052-16.091,2.492-26.023q-.012-.235-.027-.472-.126-2.148-.307-4.344h5.821q-.119,2.28-.169,4.516c0,.1,0,.2-.007.294-.186,9.544.669,18.412,3.452,26.029Z",
    transform: "translate(-289.939 -451.079)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M170.01,59.9c-.2,11.719-8.789,15.664-19.293,15.482q-.366-.006-.728-.019-.73-.026-1.444-.079c-9.471-.713-16.762-5.142-16.574-16.041.2-11.279,18.577-24.137,19.917-25.167C151.888,34.075,170.212,48.181,170.01,59.9Z",
    transform: "translate(-131.966 -34.075)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M303.369,75.657l-.135-1.42-.666-3.1L301.1,64.317l6.5-11.9-6.48,10.39.07-4.324,4.483-8.61-4.464,7.464.127-7.778,4.8-6.854-4.779,5.631.078-14.2v-.06l0,.061-.473,18.009L296.1,44.707l4.8,8.965-.455,8.687-.014-.23-5.626-7.862,5.609,8.676-.056,1.086-.011.017,0,.089-1.44,7.005-.893,4.344q.015.236.027.472c.819.018,4.776-.011,5.312-.006Z",
    transform: "translate(-281.517 -34.075)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(0 45.605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M3.525,261.6v3.464l-1.857-.813-.12-.052-.388-.17-.988-.433a.287.287,0,0,1,0-.526l1-.44.372-.163.091-.04Z",
    transform: "translate(0 -254.642)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(7.759 11.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M264.116,429.868v1.439a.233.233,0,1,1-.466,0v-1.439Z",
    transform: "translate(-263.65 -429.868)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M304.93,429.868v1.439a.233.233,0,1,1-.466,0v-1.439Z",
    transform: "translate(-303.263 -429.868)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M226.217,27.947l-.763,1.429-.275.515-.466.873-.007.013a.4.4,0,0,1-.494.191.4.4,0,0,1-.247-.25l-1.042-3.034a1.8,1.8,0,0,1,.422-1.848,1.755,1.755,0,0,1,.52-.365,1.733,1.733,0,0,1,.814-.154l.055,0,.035,0,.034,0,.056.005A1.783,1.783,0,0,1,226.217,27.947Z",
    transform: "translate(-216.267 -25.315)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M225.454,34.535l-.275.515-.466.873-.007.013a.4.4,0,0,1-.494.191.4.4,0,0,1-.247-.25l-1.042-3.034a1.8,1.8,0,0,1,.422-1.848,1.755,1.755,0,0,1,.52-.365,2.18,2.18,0,0,1,1.171,1.571Z",
    transform: "translate(-216.267 -30.474)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M154.623,55.847l-.539-3.013a1.7,1.7,0,0,0-2.562-1.159l-.045.029-.027.019-.028.018-.044.03a1.7,1.7,0,0,0,.081,2.811l2.572,1.659A.387.387,0,0,0,154.623,55.847Z",
    transform: "translate(-146.241 -50.652)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M400.3,113.02a.559.559,0,0,0-.908.489l-.025.008a4.129,4.129,0,0,0-1.9,2.309.233.233,0,1,0,.434.17,3.711,3.711,0,0,1,1.633-2.044.233.233,0,0,0,.078-.05.559.559,0,0,0,.686-.882Z",
    transform: "translate(-385.758 -110.319)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M39.591,261.6v3.464l-1.857-.813-.12-.052-.388-.17a3.334,3.334,0,0,1,.016-1.4l.372-.163.091-.04Z",
    transform: "translate(-36.067 -254.642)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    d: "M84.907,210.3a3.312,3.312,0,0,1-.441,1.654,3.365,3.365,0,0,1-.54.7,3.331,3.331,0,0,1-2.359.981H75.3a3.336,3.336,0,0,1-2.359-5.7,3.353,3.353,0,0,1,2.359-.981h6.271A3.35,3.35,0,0,1,84.907,210.3Z",
    transform: "translate(-69.839 -201.618)",
    fill: "#eebf00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(2.118 5.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    d: "M84.907,210.3a3.312,3.312,0,0,1-.441,1.654,3.365,3.365,0,0,1-.54.7,3.331,3.331,0,0,1-2.359.981H75.3a3.336,3.336,0,0,1-2.359-5.7,3.353,3.353,0,0,1,2.359-.981h6.271A3.35,3.35,0,0,1,84.907,210.3Z",
    transform: "translate(-71.957 -206.964)",
    fill: "#f8d181"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M113.591,210.3a2.049,2.049,0,0,1-2.47,2.346H104.85a3.349,3.349,0,0,1-3.34-3.34,2.049,2.049,0,0,1,2.47-2.346h6.271A3.35,3.35,0,0,1,113.591,210.3Z",
    transform: "translate(-98.523 -201.619)",
    fill: "#ffdf9c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 0.432,
    cy: 0.432,
    rx: 0.432,
    ry: 0.432,
    transform: "translate(12.434 7.202)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(5.985 5.346)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 1.466,
    height: 6.68,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 1.465,
    height: 6.68,
    transform: "translate(3.749)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(5.985 11.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M204.848,399.575v.993h-1.465v-1.012a3.119,3.119,0,0,0,.342.019Z",
    transform: "translate(-203.383 -399.556)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 1.465,
    height: 0.994,
    transform: "translate(3.749 0.018)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M223.312,429.868v1.439a.233.233,0,1,1-.466,0v-1.439Z",
    transform: "translate(-222.273 -428.976)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M345.745,429.868v1.439a.233.233,0,1,1-.466,0v-1.439Z",
    transform: "translate(-341.103 -428.976)",
    fill: "#3f3d56"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(27.356 10.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54-2",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376-2",
    "data-name": "Path 376",
    d: "M6.072,261.6v5.967l-3.2-1.4-.207-.09L2,265.778l-1.7-.746a.494.494,0,0,1,0-.905l1.73-.758.642-.281.157-.068Z",
    transform: "translate(0 -249.617)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29-2",
    "data-name": "Group 29",
    transform: "translate(13.366 20.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358-2",
    "data-name": "Path 358",
    d: "M264.453,429.868v2.479a.4.4,0,0,1-.8,0v-2.479Z",
    transform: "translate(-263.65 -429.868)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359-2",
    "data-name": "Path 359",
    d: "M305.267,429.868v2.479a.4.4,0,0,1-.8,0v-2.479Z",
    transform: "translate(-302.395 -429.868)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_372-2",
    "data-name": "Path 372",
    d: "M228.668,29.85l-1.314,2.461-.474.887-.8,1.5-.012.022a.694.694,0,0,1-.852.329.682.682,0,0,1-.425-.431L222.995,29.4a3.093,3.093,0,0,1,.727-3.184,3.024,3.024,0,0,1,.9-.629,2.986,2.986,0,0,1,1.4-.265l.1.006.059.005.059,0,.1.009A3.072,3.072,0,0,1,228.668,29.85Z",
    transform: "translate(-211.528 -25.315)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373-2",
    "data-name": "Path 373",
    d: "M227.354,37.357l-.474.887-.8,1.5-.012.022a.694.694,0,0,1-.852.329.682.682,0,0,1-.425-.431l-1.794-5.226a3.093,3.093,0,0,1,.727-3.184,3.024,3.024,0,0,1,.9-.629,3.756,3.756,0,0,1,2.018,2.706Z",
    transform: "translate(-211.528 -30.361)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374-2",
    "data-name": "Path 374",
    d: "M157.477,59.046l-.928-5.19a2.931,2.931,0,0,0-4.414-2l-.077.05-.047.032-.047.031-.075.052a2.931,2.931,0,0,0,.14,4.843l4.431,2.858A.667.667,0,0,0,157.477,59.046Z",
    transform: "translate(-143.037 -50.097)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375-2",
    "data-name": "Path 375",
    d: "M402.36,113.11a.963.963,0,0,0-1.563.843l-.043.014c-1.651.638-2.78,2.727-3.271,3.977a.4.4,0,1,0,.747.293c.432-1.1,1.435-2.989,2.814-3.522a.4.4,0,0,0,.135-.086.963.963,0,0,0,1.182-1.519Z",
    transform: "translate(-377.304 -108.456)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377-2",
    "data-name": "Path 377",
    d: "M41.348,261.6v5.967l-3.2-1.4-.207-.09-.669-.293a5.743,5.743,0,0,1,.027-2.41l.642-.281.157-.068Z",
    transform: "translate(-35.276 -249.617)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0-2",
    "data-name": "SVGCleanerId_0",
    d: "M94.267,212.718a5.705,5.705,0,0,1-.76,2.849,5.8,5.8,0,0,1-.93,1.214,5.738,5.738,0,0,1-4.063,1.69H77.71a5.747,5.747,0,0,1-4.064-9.817,5.776,5.776,0,0,1,4.064-1.69h10.8A5.771,5.771,0,0,1,94.267,212.718Z",
    transform: "translate(-68.309 -197.755)",
    fill: "#eebf00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26-2",
    "data-name": "Group 26",
    transform: "translate(3.648 9.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_2",
    "data-name": "SVGCleanerId_0_1_",
    d: "M94.267,212.718a5.705,5.705,0,0,1-.76,2.849,5.8,5.8,0,0,1-.93,1.214,5.738,5.738,0,0,1-4.063,1.69H77.71a5.747,5.747,0,0,1-4.064-9.817,5.776,5.776,0,0,1,4.064-1.69h10.8A5.771,5.771,0,0,1,94.267,212.718Z",
    transform: "translate(-71.957 -206.964)",
    fill: "#f8d181"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_371-2",
    "data-name": "Path 371",
    d: "M122.321,212.718a5.705,5.705,0,0,1-.76,2.849,5.716,5.716,0,0,1-3.495,1.192h-10.8a5.77,5.77,0,0,1-5.753-5.753,5.7,5.7,0,0,1,.761-2.85,5.715,5.715,0,0,1,3.494-1.191h10.8A5.77,5.77,0,0,1,122.321,212.718Z",
    transform: "translate(-96.364 -197.756)",
    fill: "#ffdf9c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_55-2",
    "data-name": "Ellipse 55",
    cx: 0.745,
    cy: 0.745,
    rx: 0.745,
    ry: 0.745,
    transform: "translate(21.42 12.406)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27-2",
    "data-name": "Group 27",
    transform: "translate(10.311 9.209)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-2",
    "data-name": "Rectangle 16",
    width: 2.525,
    height: 11.507,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-2",
    "data-name": "Rectangle 17",
    width: 2.524,
    height: 11.507,
    transform: "translate(6.459)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28-2",
    "data-name": "Group 28",
    transform: "translate(10.311 18.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367-2",
    "data-name": "Path 367",
    d: "M205.908,399.588V401.3h-2.525v-1.743a5.361,5.361,0,0,0,.589.032Z",
    transform: "translate(-203.383 -399.556)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-2",
    "data-name": "Rectangle 18",
    width: 2.524,
    height: 1.712,
    transform: "translate(6.459 0.03)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368-2",
    "data-name": "Path 368",
    d: "M223.649,429.868v2.479a.4.4,0,0,1-.8,0v-2.479Z",
    transform: "translate(-221.859 -428.331)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369-2",
    "data-name": "Path 369",
    d: "M346.082,429.868v2.479a.4.4,0,0,1-.8,0v-2.479Z",
    transform: "translate(-338.085 -428.331)",
    fill: "#3f3d56"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(1384.647 1093.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(11.75 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M918.9,533.263a47.174,47.174,0,0,1,2.065,18.577,44.817,44.817,0,0,1-11.528-34.7A47.171,47.171,0,0,1,918.9,533.263Z",
    transform: "translate(-909.244 -515.173)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M1013.807,533.263a47.172,47.172,0,0,0-2.065,18.577,44.817,44.817,0,0,0,11.528-34.7A47.17,47.17,0,0,0,1013.807,533.263Z",
    transform: "translate(-1000.023 -515.173)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M981.511,517.842A47.172,47.172,0,0,1,978,536.2a44.817,44.817,0,0,1-.773-36.552A47.165,47.165,0,0,1,981.511,517.842Z",
    transform: "translate(-966.445 -499.648)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 9.003,
    cy: 0.494,
    rx: 9.003,
    ry: 0.494,
    transform: "translate(2.551 36.172)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 0.988,
    cy: 0.988,
    rx: 0.988,
    ry: 0.988,
    transform: "translate(10.182 8.285)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 0.549,
    cy: 0.549,
    rx: 0.549,
    ry: 0.549,
    transform: "translate(8.699 16.629)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 0.549,
    cy: 0.549,
    rx: 0.549,
    ry: 0.549,
    transform: "translate(2.002 11.195)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 0.549,
    cy: 0.549,
    rx: 0.549,
    ry: 0.549,
    transform: "translate(4.857 16.355)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 0.549,
    cy: 0.549,
    rx: 0.549,
    ry: 0.549,
    transform: "translate(16.385 13.171)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 0.549,
    cy: 0.549,
    rx: 0.549,
    ry: 0.549,
    transform: "translate(5.186 24.425)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 0.549,
    cy: 0.549,
    rx: 0.549,
    ry: 0.549,
    transform: "translate(16.934 21.296)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 0.549,
    cy: 0.549,
    rx: 0.549,
    ry: 0.549,
    transform: "translate(11.609 21.844)",
    fill: "#00a050"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(0 11.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376-3",
    "data-name": "Path 376",
    d: "M3.751,261.6v3.686l-1.976-.866-.128-.056-.413-.181-1.052-.461a.305.305,0,0,1,0-.559l1.069-.468.4-.173.1-.042Z",
    transform: "translate(0 -254.196)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29-3",
    "data-name": "Group 29",
    transform: "translate(8.257 12.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358-3",
    "data-name": "Path 358",
    d: "M264.146,429.868V431.4a.248.248,0,1,1-.5,0v-1.531Z",
    transform: "translate(-263.65 -429.868)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359-3",
    "data-name": "Path 359",
    d: "M304.96,429.868V431.4a.248.248,0,1,1-.5,0v-1.531Z",
    transform: "translate(-303.186 -429.868)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_372-3",
    "data-name": "Path 372",
    d: "M226.434,28.116l-.811,1.521-.293.548-.5.929-.008.014a.429.429,0,0,1-.526.2.421.421,0,0,1-.263-.266l-1.108-3.228a1.91,1.91,0,0,1,.449-1.967,1.868,1.868,0,0,1,.553-.388,1.845,1.845,0,0,1,.866-.164l.059,0,.037,0,.036,0,.059.006A1.9,1.9,0,0,1,226.434,28.116Z",
    transform: "translate(-215.847 -25.315)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373-3",
    "data-name": "Path 373",
    d: "M225.623,34.786l-.293.548-.5.929-.008.014a.429.429,0,0,1-.526.2.421.421,0,0,1-.263-.266l-1.108-3.228a1.91,1.91,0,0,1,.449-1.967,1.868,1.868,0,0,1,.553-.388,2.32,2.32,0,0,1,1.246,1.672Z",
    transform: "translate(-215.847 -30.464)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374-3",
    "data-name": "Path 374",
    d: "M154.877,56.131l-.574-3.206a1.81,1.81,0,0,0-2.727-1.234l-.047.031-.029.02-.029.019-.047.032a1.81,1.81,0,0,0,.087,2.991l2.737,1.766A.412.412,0,0,0,154.877,56.131Z",
    transform: "translate(-145.957 -50.603)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375-3",
    "data-name": "Path 375",
    d: "M400.485,113.028a.595.595,0,0,0-.966.521l-.026.008a4.394,4.394,0,0,0-2.021,2.457.248.248,0,1,0,.461.181,3.949,3.949,0,0,1,1.738-2.176.246.246,0,0,0,.083-.053.595.595,0,0,0,.73-.938Z",
    transform: "translate(-385.007 -110.153)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377-3",
    "data-name": "Path 377",
    d: "M39.747,261.6v3.686l-1.976-.866-.128-.056-.413-.181a3.548,3.548,0,0,1,.017-1.488l.4-.173.1-.042Z",
    transform: "translate(-35.996 -254.196)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0-3",
    "data-name": "SVGCleanerId_0",
    d: "M85.738,210.518a3.524,3.524,0,0,1-.47,1.76,3.581,3.581,0,0,1-.574.75,3.544,3.544,0,0,1-2.51,1.044H75.511A3.55,3.55,0,0,1,73,208.008a3.568,3.568,0,0,1,2.51-1.044h6.673A3.565,3.565,0,0,1,85.738,210.518Z",
    transform: "translate(-69.704 -201.275)",
    fill: "#eebf00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26-3",
    "data-name": "Group 26",
    transform: "translate(2.253 5.689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_3",
    "data-name": "SVGCleanerId_0_1_",
    d: "M85.738,210.518a3.524,3.524,0,0,1-.47,1.76,3.581,3.581,0,0,1-.574.75,3.544,3.544,0,0,1-2.51,1.044H75.511A3.55,3.55,0,0,1,73,208.008a3.568,3.568,0,0,1,2.51-1.044h6.673A3.565,3.565,0,0,1,85.738,210.518Z",
    transform: "translate(-71.957 -206.964)",
    fill: "#f8d181"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_371-3",
    "data-name": "Path 371",
    d: "M114.366,210.519a2.18,2.18,0,0,1-2.629,2.5h-6.673a3.564,3.564,0,0,1-3.554-3.554,2.18,2.18,0,0,1,2.629-2.5h6.673A3.565,3.565,0,0,1,114.366,210.519Z",
    transform: "translate(-98.331 -201.276)",
    fill: "#ffdf9c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_55-3",
    "data-name": "Ellipse 55",
    cx: 0.46,
    cy: 0.46,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(13.232 7.664)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27-3",
    "data-name": "Group 27",
    transform: "translate(6.37 5.689)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-3",
    "data-name": "Rectangle 16",
    width: 1.56,
    height: 7.108,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-3",
    "data-name": "Rectangle 17",
    width: 1.559,
    height: 7.108,
    transform: "translate(3.99)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28-3",
    "data-name": "Group 28",
    transform: "translate(6.37 11.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367-3",
    "data-name": "Path 367",
    d: "M204.943,399.576v1.057h-1.56v-1.077a3.312,3.312,0,0,0,.364.02Z",
    transform: "translate(-203.383 -399.556)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-3",
    "data-name": "Rectangle 18",
    width: 1.559,
    height: 1.058,
    transform: "translate(3.99 0.019)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368-3",
    "data-name": "Path 368",
    d: "M223.342,429.868V431.4a.248.248,0,1,1-.5,0v-1.531Z",
    transform: "translate(-222.236 -428.919)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369-3",
    "data-name": "Path 369",
    d: "M345.775,429.868V431.4a.248.248,0,1,1-.5,0v-1.531Z",
    transform: "translate(-340.835 -428.919)",
    fill: "#3f3d56"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(18.836 19.462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376-4",
    "data-name": "Path 376",
    d: "M6.072,261.6v5.967l-3.2-1.4-.207-.09L2,265.778l-1.7-.746a.494.494,0,0,1,0-.905l1.73-.758.642-.281.157-.068Z",
    transform: "translate(0 -249.617)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29-4",
    "data-name": "Group 29",
    transform: "translate(13.366 20.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358-4",
    "data-name": "Path 358",
    d: "M264.453,429.868v2.479a.4.4,0,0,1-.8,0v-2.479Z",
    transform: "translate(-263.65 -429.868)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359-4",
    "data-name": "Path 359",
    d: "M305.267,429.868v2.479a.4.4,0,0,1-.8,0v-2.479Z",
    transform: "translate(-302.395 -429.868)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_372-4",
    "data-name": "Path 372",
    d: "M228.668,29.85l-1.314,2.461-.474.887-.8,1.5-.012.022a.694.694,0,0,1-.852.329.682.682,0,0,1-.425-.431L222.995,29.4a3.093,3.093,0,0,1,.727-3.184,3.024,3.024,0,0,1,.9-.629,2.986,2.986,0,0,1,1.4-.265l.1.006.059.005.059,0,.1.009A3.072,3.072,0,0,1,228.668,29.85Z",
    transform: "translate(-211.528 -25.315)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373-4",
    "data-name": "Path 373",
    d: "M227.354,37.357l-.474.887-.8,1.5-.012.022a.694.694,0,0,1-.852.329.682.682,0,0,1-.425-.431l-1.794-5.226a3.093,3.093,0,0,1,.727-3.184,3.024,3.024,0,0,1,.9-.629,3.756,3.756,0,0,1,2.018,2.706Z",
    transform: "translate(-211.528 -30.361)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374-4",
    "data-name": "Path 374",
    d: "M157.477,59.046l-.928-5.19a2.931,2.931,0,0,0-4.414-2l-.077.05-.047.032-.047.031-.075.052a2.931,2.931,0,0,0,.14,4.843l4.431,2.858A.667.667,0,0,0,157.477,59.046Z",
    transform: "translate(-143.037 -50.097)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375-4",
    "data-name": "Path 375",
    d: "M402.36,113.11a.963.963,0,0,0-1.563.843l-.043.014c-1.651.638-2.78,2.727-3.271,3.977a.4.4,0,1,0,.747.293c.432-1.1,1.435-2.989,2.814-3.522a.4.4,0,0,0,.135-.086.963.963,0,0,0,1.182-1.519Z",
    transform: "translate(-377.304 -108.456)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377-4",
    "data-name": "Path 377",
    d: "M41.348,261.6v5.967l-3.2-1.4-.207-.09-.669-.293a5.743,5.743,0,0,1,.027-2.41l.642-.281.157-.068Z",
    transform: "translate(-35.276 -249.617)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0-4",
    "data-name": "SVGCleanerId_0",
    d: "M94.267,212.718a5.705,5.705,0,0,1-.76,2.849,5.8,5.8,0,0,1-.93,1.214,5.738,5.738,0,0,1-4.063,1.69H77.71a5.747,5.747,0,0,1-4.064-9.817,5.776,5.776,0,0,1,4.064-1.69h10.8A5.771,5.771,0,0,1,94.267,212.718Z",
    transform: "translate(-68.309 -197.755)",
    fill: "#eebf00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26-4",
    "data-name": "Group 26",
    transform: "translate(3.648 9.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_4",
    "data-name": "SVGCleanerId_0_1_",
    d: "M94.267,212.718a5.705,5.705,0,0,1-.76,2.849,5.8,5.8,0,0,1-.93,1.214,5.738,5.738,0,0,1-4.063,1.69H77.71a5.747,5.747,0,0,1-4.064-9.817,5.776,5.776,0,0,1,4.064-1.69h10.8A5.771,5.771,0,0,1,94.267,212.718Z",
    transform: "translate(-71.957 -206.964)",
    fill: "#f8d181"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_371-4",
    "data-name": "Path 371",
    d: "M122.321,212.718a5.705,5.705,0,0,1-.76,2.849,5.716,5.716,0,0,1-3.495,1.192h-10.8a5.77,5.77,0,0,1-5.753-5.753,5.7,5.7,0,0,1,.761-2.85,5.715,5.715,0,0,1,3.494-1.191h10.8A5.77,5.77,0,0,1,122.321,212.718Z",
    transform: "translate(-96.364 -197.756)",
    fill: "#ffdf9c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_55-4",
    "data-name": "Ellipse 55",
    cx: 0.745,
    cy: 0.745,
    rx: 0.745,
    ry: 0.745,
    transform: "translate(21.42 12.406)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27-4",
    "data-name": "Group 27",
    transform: "translate(10.311 9.209)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-4",
    "data-name": "Rectangle 16",
    width: 2.525,
    height: 11.507,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-4",
    "data-name": "Rectangle 17",
    width: 2.524,
    height: 11.507,
    transform: "translate(6.459)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28-4",
    "data-name": "Group 28",
    transform: "translate(10.311 18.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367-4",
    "data-name": "Path 367",
    d: "M205.908,399.588V401.3h-2.525v-1.743a5.361,5.361,0,0,0,.589.032Z",
    transform: "translate(-203.383 -399.556)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-4",
    "data-name": "Rectangle 18",
    width: 2.524,
    height: 1.712,
    transform: "translate(6.459 0.03)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368-4",
    "data-name": "Path 368",
    d: "M223.649,429.868v2.479a.4.4,0,0,1-.8,0v-2.479Z",
    transform: "translate(-221.859 -428.331)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369-4",
    "data-name": "Path 369",
    d: "M346.082,429.868v2.479a.4.4,0,0,1-.8,0v-2.479Z",
    transform: "translate(-338.085 -428.331)",
    fill: "#3f3d56"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(1400.267 1066.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376-5",
    "data-name": "Path 376",
    d: "M4.642,261.6v4.562L2.2,265.087l-.158-.069-.511-.224-1.3-.57a.378.378,0,0,1,0-.692l1.323-.58.491-.215.12-.052Z",
    transform: "translate(0 -252.438)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29-5",
    "data-name": "Group 29",
    transform: "translate(10.219 15.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358-5",
    "data-name": "Path 358",
    d: "M264.264,429.868v1.9a.307.307,0,1,1-.614,0v-1.9Z",
    transform: "translate(-263.65 -429.868)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359-5",
    "data-name": "Path 359",
    d: "M305.078,429.868v1.9a.307.307,0,1,1-.614,0v-1.9Z",
    transform: "translate(-302.882 -429.868)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_372-5",
    "data-name": "Path 372",
    d: "M227.292,28.782l-1,1.882-.362.678-.613,1.15-.009.017a.531.531,0,0,1-.651.252.521.521,0,0,1-.325-.33l-1.372-4A2.364,2.364,0,0,1,223.511,26a2.312,2.312,0,0,1,.684-.481,2.283,2.283,0,0,1,1.072-.2l.073,0,.045,0,.045,0,.073.007A2.348,2.348,0,0,1,227.292,28.782Z",
    transform: "translate(-214.188 -25.315)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373-5",
    "data-name": "Path 373",
    d: "M226.288,35.773l-.362.678-.613,1.15-.009.017a.531.531,0,0,1-.651.252.521.521,0,0,1-.325-.33l-1.372-4a2.364,2.364,0,0,1,.556-2.434,2.312,2.312,0,0,1,.684-.481,2.871,2.871,0,0,1,1.543,2.069Z",
    transform: "translate(-214.188 -30.424)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374-5",
    "data-name": "Path 374",
    d: "M155.875,57.25l-.71-3.968a2.241,2.241,0,0,0-3.375-1.527l-.059.038-.036.024-.036.024-.058.04a2.241,2.241,0,0,0,.107,3.7l3.387,2.185A.51.51,0,0,0,155.875,57.25Z",
    transform: "translate(-144.836 -50.409)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375-5",
    "data-name": "Path 375",
    d: "M401.2,113.06a.736.736,0,0,0-1.2.644l-.033.01a5.438,5.438,0,0,0-2.5,3.041.307.307,0,1,0,.571.224,4.888,4.888,0,0,1,2.151-2.693.305.305,0,0,0,.1-.066.736.736,0,0,0,.9-1.161Z",
    transform: "translate(-382.049 -109.501)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377-5",
    "data-name": "Path 377",
    d: "M40.362,261.6v4.562l-2.445-1.071-.158-.069-.511-.224a4.391,4.391,0,0,1,.021-1.842l.491-.215.12-.052Z",
    transform: "translate(-35.72 -252.438)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0-5",
    "data-name": "SVGCleanerId_0",
    d: "M89.013,211.363a4.362,4.362,0,0,1-.581,2.178,4.431,4.431,0,0,1-.711.928,4.386,4.386,0,0,1-3.106,1.292H76.356a4.394,4.394,0,0,1-3.107-7.505,4.416,4.416,0,0,1,3.107-1.292h8.259A4.412,4.412,0,0,1,89.013,211.363Z",
    transform: "translate(-69.168 -199.923)",
    fill: "#eebf00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26-5",
    "data-name": "Group 26",
    transform: "translate(2.789 7.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_5",
    "data-name": "SVGCleanerId_0_1_",
    d: "M89.013,211.363a4.362,4.362,0,0,1-.581,2.178,4.431,4.431,0,0,1-.711.928,4.386,4.386,0,0,1-3.106,1.292H76.356a4.394,4.394,0,0,1-3.107-7.505,4.416,4.416,0,0,1,3.107-1.292h8.259A4.412,4.412,0,0,1,89.013,211.363Z",
    transform: "translate(-71.957 -206.964)",
    fill: "#f8d181"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_371-5",
    "data-name": "Path 371",
    d: "M117.42,211.364a2.7,2.7,0,0,1-3.253,3.089h-8.259a4.411,4.411,0,0,1-4.4-4.4,4.359,4.359,0,0,1,.582-2.179,4.369,4.369,0,0,1,2.671-.911h8.259A4.412,4.412,0,0,1,117.42,211.364Z",
    transform: "translate(-97.576 -199.924)",
    fill: "#ffdf9c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_55-5",
    "data-name": "Ellipse 55",
    cx: 0.57,
    cy: 0.57,
    rx: 0.57,
    ry: 0.57,
    transform: "translate(16.376 9.485)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27-5",
    "data-name": "Group 27",
    transform: "translate(7.883 7.041)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-5",
    "data-name": "Rectangle 16",
    width: 1.93,
    height: 8.797,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-5",
    "data-name": "Rectangle 17",
    width: 1.93,
    height: 8.797,
    transform: "translate(4.938)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28-5",
    "data-name": "Group 28",
    transform: "translate(7.883 14.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367-5",
    "data-name": "Path 367",
    d: "M205.313,399.581v1.308h-1.93v-1.332a4.105,4.105,0,0,0,.45.025Z",
    transform: "translate(-203.383 -399.556)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-5",
    "data-name": "Rectangle 18",
    width: 1.93,
    height: 1.309,
    transform: "translate(4.938 0.023)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368-5",
    "data-name": "Path 368",
    d: "M223.46,429.868v1.9a.307.307,0,1,1-.614,0v-1.9Z",
    transform: "translate(-222.092 -428.693)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369-5",
    "data-name": "Path 369",
    d: "M345.893,429.868v1.9a.307.307,0,1,1-.614,0v-1.9Z",
    transform: "translate(-339.779 -428.693)",
    fill: "#3f3d56"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(1375 1068.355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376-6",
    "data-name": "Path 376",
    d: "M4.052,261.6v3.982l-2.134-.935-.138-.06-.446-.2-1.136-.5a.33.33,0,0,1,0-.6l1.154-.506.428-.187.1-.046Z",
    transform: "translate(0 -253.603)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29-6",
    "data-name": "Group 29",
    transform: "translate(8.919 13.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358-6",
    "data-name": "Path 358",
    d: "M264.186,429.868v1.654a.268.268,0,0,1-.536,0v-1.654Z",
    transform: "translate(-263.65 -429.868)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359-6",
    "data-name": "Path 359",
    d: "M305,429.868v1.654a.268.268,0,0,1-.536,0v-1.654Z",
    transform: "translate(-303.083 -429.868)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_372-6",
    "data-name": "Path 372",
    d: "M226.724,28.341l-.877,1.642-.316.592-.535,1-.008.015a.463.463,0,0,1-.568.22.455.455,0,0,1-.284-.288l-1.2-3.487a2.064,2.064,0,0,1,.485-2.125,2.018,2.018,0,0,1,.6-.42,1.993,1.993,0,0,1,.936-.177l.064,0,.04,0,.039,0,.064.006A2.05,2.05,0,0,1,226.724,28.341Z",
    transform: "translate(-215.287 -25.315)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373-6",
    "data-name": "Path 373",
    d: "M225.847,35.119l-.316.592-.535,1-.008.015a.463.463,0,0,1-.568.22.455.455,0,0,1-.284-.288l-1.2-3.487a2.064,2.064,0,0,1,.485-2.125,2.018,2.018,0,0,1,.6-.42,2.506,2.506,0,0,1,1.346,1.806Z",
    transform: "translate(-215.287 -30.45)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374-6",
    "data-name": "Path 374",
    d: "M155.214,56.509l-.619-3.463a1.956,1.956,0,0,0-2.945-1.333l-.051.033-.031.021-.032.021-.05.035a1.956,1.956,0,0,0,.094,3.231l2.957,1.907A.445.445,0,0,0,155.214,56.509Z",
    transform: "translate(-145.578 -50.537)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375-6",
    "data-name": "Path 375",
    d: "M400.728,113.039a.642.642,0,0,0-1.043.562l-.028.009a4.747,4.747,0,0,0-2.183,2.654.268.268,0,1,0,.5.2,4.266,4.266,0,0,1,1.878-2.35.267.267,0,0,0,.09-.057.642.642,0,0,0,.789-1.014Z",
    transform: "translate(-384.009 -109.933)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377-6",
    "data-name": "Path 377",
    d: "M39.955,261.6v3.982l-2.134-.935-.138-.06-.446-.2a3.832,3.832,0,0,1,.018-1.608l.428-.187.1-.046Z",
    transform: "translate(-35.903 -253.603)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0-6",
    "data-name": "SVGCleanerId_0",
    d: "M86.844,210.8a3.807,3.807,0,0,1-.507,1.9,3.868,3.868,0,0,1-.621.81A3.829,3.829,0,0,1,83,214.642H75.8a3.835,3.835,0,0,1-2.712-6.551,3.775,3.775,0,0,1,.38-.333,3.814,3.814,0,0,1,2.332-.795H83A3.851,3.851,0,0,1,86.844,210.8Z",
    transform: "translate(-69.523 -200.819)",
    fill: "#eebf00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26-6",
    "data-name": "Group 26",
    transform: "translate(2.434 6.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_6",
    "data-name": "SVGCleanerId_0_1_",
    d: "M86.844,210.8a3.807,3.807,0,0,1-.507,1.9,3.868,3.868,0,0,1-.621.81A3.829,3.829,0,0,1,83,214.642H75.8a3.835,3.835,0,0,1-2.712-6.551,3.775,3.775,0,0,1,.38-.333,3.814,3.814,0,0,1,2.332-.795H83A3.851,3.851,0,0,1,86.844,210.8Z",
    transform: "translate(-71.957 -206.964)",
    fill: "#f8d181"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_371-6",
    "data-name": "Path 371",
    d: "M115.4,210.8a2.355,2.355,0,0,1-2.839,2.7h-7.208a3.85,3.85,0,0,1-3.839-3.839,2.355,2.355,0,0,1,2.839-2.7h7.208A3.851,3.851,0,0,1,115.4,210.8Z",
    transform: "translate(-98.076 -200.82)",
    fill: "#ffdf9c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_55-6",
    "data-name": "Ellipse 55",
    cx: 0.497,
    cy: 0.497,
    rx: 0.497,
    ry: 0.497,
    transform: "translate(14.293 8.279)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27-6",
    "data-name": "Group 27",
    transform: "translate(6.88 6.145)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-6",
    "data-name": "Rectangle 16",
    width: 1.685,
    height: 7.678,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-6",
    "data-name": "Rectangle 17",
    width: 1.684,
    height: 7.678,
    transform: "translate(4.31)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28-6",
    "data-name": "Group 28",
    transform: "translate(6.88 12.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367-6",
    "data-name": "Path 367",
    d: "M205.068,399.577v1.142h-1.685v-1.163a3.583,3.583,0,0,0,.393.021Z",
    transform: "translate(-203.383 -399.556)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-6",
    "data-name": "Rectangle 18",
    width: 1.684,
    height: 1.143,
    transform: "translate(4.31 0.02)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368-6",
    "data-name": "Path 368",
    d: "M223.382,429.868v1.654a.268.268,0,0,1-.536,0v-1.654Z",
    transform: "translate(-222.188 -428.842)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369-6",
    "data-name": "Path 369",
    d: "M345.815,429.868v1.654a.268.268,0,0,1-.536,0v-1.654Z",
    transform: "translate(-340.479 -428.842)",
    fill: "#3f3d56"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(1384.825 1036.866)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 10.796,
    cy: 10.796,
    r: 10.796,
    transform: "translate(0.811 0)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    y1: 39.869,
    x2: 0.621,
    transform: "translate(10.996 10.784)",
    fill: "#3f3d56",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 2.769,
    cy: 2.769,
    r: 2.769,
    transform: "translate(8.847 8.015)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M235.306,352.465s-.263-8.514-8.388-7.652",
    transform: "translate(-223.865 -330.403)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M233.549,465.514s2.035-16.334-8.238-17.285",
    transform: "translate(-222.541 -415.621)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 2.769,
    cy: 2.769,
    r: 2.769,
    transform: "translate(0 29.837)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(1394.479 1050.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376-7",
    "data-name": "Path 376",
    d: "M4.126,261.6v4.055L1.953,264.7l-.14-.061-.455-.2L.2,263.931a.336.336,0,0,1,0-.615l1.176-.515.436-.191.107-.047Z",
    transform: "translate(0 -253.455)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29-7",
    "data-name": "Group 29",
    transform: "translate(9.084 13.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358-7",
    "data-name": "Path 358",
    d: "M264.2,429.868v1.685a.273.273,0,0,1-.545,0v-1.685Z",
    transform: "translate(-263.65 -429.868)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359-7",
    "data-name": "Path 359",
    d: "M305.009,429.868v1.685a.273.273,0,0,1-.545,0v-1.685Z",
    transform: "translate(-303.058 -429.868)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_372-7",
    "data-name": "Path 372",
    d: "M226.8,28.4,225.9,30.07l-.322.6-.545,1.022-.008.015a.472.472,0,0,1-.579.224.463.463,0,0,1-.289-.293l-1.219-3.552a2.1,2.1,0,0,1,.494-2.164,2.055,2.055,0,0,1,.608-.427,2.029,2.029,0,0,1,.953-.18l.065,0,.04,0,.04,0,.065.006A2.087,2.087,0,0,1,226.8,28.4Z",
    transform: "translate(-215.148 -25.315)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373-7",
    "data-name": "Path 373",
    d: "M225.9,35.2l-.322.6-.545,1.022-.008.015a.472.472,0,0,1-.579.224.463.463,0,0,1-.289-.293l-1.219-3.552a2.1,2.1,0,0,1,.494-2.164,2.055,2.055,0,0,1,.608-.427,2.552,2.552,0,0,1,1.371,1.839Z",
    transform: "translate(-215.148 -30.447)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374-7",
    "data-name": "Path 374",
    d: "M155.3,56.6l-.631-3.527a1.992,1.992,0,0,0-3-1.357l-.052.034-.032.022-.032.021-.051.035a1.992,1.992,0,0,0,.1,3.291l3.011,1.942A.453.453,0,0,0,155.3,56.6Z",
    transform: "translate(-145.484 -50.521)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375-7",
    "data-name": "Path 375",
    d: "M400.788,113.041a.654.654,0,0,0-1.063.573l-.029.009a4.834,4.834,0,0,0-2.223,2.7.273.273,0,1,0,.508.2,4.345,4.345,0,0,1,1.912-2.393.271.271,0,0,0,.091-.058.654.654,0,0,0,.8-1.032Z",
    transform: "translate(-383.761 -109.879)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377-7",
    "data-name": "Path 377",
    d: "M40.006,261.6v4.055l-2.174-.952-.14-.061-.455-.2a3.9,3.9,0,0,1,.019-1.638l.436-.191.107-.047Z",
    transform: "translate(-35.88 -253.455)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0-7",
    "data-name": "SVGCleanerId_0",
    d: "M87.118,210.874a3.877,3.877,0,0,1-.517,1.936,3.939,3.939,0,0,1-.632.825,3.9,3.9,0,0,1-2.761,1.148H75.867a3.905,3.905,0,0,1-2.762-6.672,3.926,3.926,0,0,1,2.762-1.148h7.341A3.922,3.922,0,0,1,87.118,210.874Z",
    transform: "translate(-69.478 -200.705)",
    fill: "#eebf00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26-7",
    "data-name": "Group 26",
    transform: "translate(2.479 6.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_7",
    "data-name": "SVGCleanerId_0_1_",
    d: "M87.118,210.874a3.877,3.877,0,0,1-.517,1.936,3.939,3.939,0,0,1-.632.825,3.9,3.9,0,0,1-2.761,1.148H75.867a3.905,3.905,0,0,1-2.762-6.672,3.926,3.926,0,0,1,2.762-1.148h7.341A3.922,3.922,0,0,1,87.118,210.874Z",
    transform: "translate(-71.957 -206.964)",
    fill: "#f8d181"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_371-7",
    "data-name": "Path 371",
    d: "M115.653,210.875a2.4,2.4,0,0,1-2.892,2.746H105.42a3.921,3.921,0,0,1-3.91-3.91,2.4,2.4,0,0,1,2.892-2.746h7.341A3.921,3.921,0,0,1,115.653,210.875Z",
    transform: "translate(-98.013 -200.706)",
    fill: "#ffdf9c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_55-7",
    "data-name": "Ellipse 55",
    cx: 0.506,
    cy: 0.506,
    rx: 0.506,
    ry: 0.506,
    transform: "translate(14.557 8.431)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27-7",
    "data-name": "Group 27",
    transform: "translate(7.007 6.259)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-7",
    "data-name": "Rectangle 16",
    width: 1.716,
    height: 7.82,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-7",
    "data-name": "Rectangle 17",
    width: 1.715,
    height: 7.82,
    transform: "translate(4.389)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28-7",
    "data-name": "Group 28",
    transform: "translate(7.007 12.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367-7",
    "data-name": "Path 367",
    d: "M205.1,399.578v1.163h-1.716v-1.184a3.646,3.646,0,0,0,.4.022Z",
    transform: "translate(-203.383 -399.556)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-7",
    "data-name": "Rectangle 18",
    width: 1.715,
    height: 1.164,
    transform: "translate(4.389 0.021)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368-7",
    "data-name": "Path 368",
    d: "M223.391,429.868v1.685a.273.273,0,0,1-.545,0v-1.685Z",
    transform: "translate(-222.175 -428.824)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369-7",
    "data-name": "Path 369",
    d: "M345.825,429.868v1.685a.273.273,0,0,1-.545,0v-1.685Z",
    transform: "translate(-340.39 -428.824)",
    fill: "#3f3d56"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(1454.592 1081.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(0 36.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54-3",
    "data-name": "Group 54",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376-8",
    "data-name": "Path 376",
    d: "M3.525,261.6v3.464l-1.857-.813-.12-.052-.388-.17-.988-.433a.287.287,0,0,1,0-.526l1-.44.372-.163.091-.04Z",
    transform: "translate(0 -254.642)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29-8",
    "data-name": "Group 29",
    transform: "translate(7.759 11.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358-8",
    "data-name": "Path 358",
    d: "M264.116,429.868v1.439a.233.233,0,1,1-.466,0v-1.439Z",
    transform: "translate(-263.65 -429.868)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359-8",
    "data-name": "Path 359",
    d: "M304.93,429.868v1.439a.233.233,0,1,1-.466,0v-1.439Z",
    transform: "translate(-303.263 -429.868)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_372-8",
    "data-name": "Path 372",
    d: "M226.217,27.947l-.763,1.429-.275.515-.466.873-.007.013a.4.4,0,0,1-.494.191.4.4,0,0,1-.247-.25l-1.042-3.034a1.8,1.8,0,0,1,.422-1.848,1.755,1.755,0,0,1,.52-.365,1.733,1.733,0,0,1,.814-.154l.055,0,.035,0,.034,0,.056.005A1.783,1.783,0,0,1,226.217,27.947Z",
    transform: "translate(-216.267 -25.315)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373-8",
    "data-name": "Path 373",
    d: "M225.454,34.535l-.275.515-.466.873-.007.013a.4.4,0,0,1-.494.191.4.4,0,0,1-.247-.25l-1.042-3.034a1.8,1.8,0,0,1,.422-1.848,1.755,1.755,0,0,1,.52-.365,2.18,2.18,0,0,1,1.171,1.571Z",
    transform: "translate(-216.267 -30.474)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374-8",
    "data-name": "Path 374",
    d: "M154.623,55.847l-.539-3.013a1.7,1.7,0,0,0-2.562-1.159l-.045.029-.027.019-.028.018-.044.03a1.7,1.7,0,0,0,.081,2.811l2.572,1.659A.387.387,0,0,0,154.623,55.847Z",
    transform: "translate(-146.241 -50.652)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375-8",
    "data-name": "Path 375",
    d: "M400.3,113.02a.559.559,0,0,0-.908.489l-.025.008a4.129,4.129,0,0,0-1.9,2.309.233.233,0,1,0,.434.17,3.711,3.711,0,0,1,1.633-2.044.233.233,0,0,0,.078-.05.559.559,0,0,0,.686-.882Z",
    transform: "translate(-385.758 -110.319)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377-8",
    "data-name": "Path 377",
    d: "M39.591,261.6v3.464l-1.857-.813-.12-.052-.388-.17a3.334,3.334,0,0,1,.016-1.4l.372-.163.091-.04Z",
    transform: "translate(-36.067 -254.642)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0-8",
    "data-name": "SVGCleanerId_0",
    d: "M84.907,210.3a3.312,3.312,0,0,1-.441,1.654,3.365,3.365,0,0,1-.54.7,3.331,3.331,0,0,1-2.359.981H75.3a3.336,3.336,0,0,1-2.359-5.7,3.353,3.353,0,0,1,2.359-.981h6.271A3.35,3.35,0,0,1,84.907,210.3Z",
    transform: "translate(-69.839 -201.618)",
    fill: "#eebf00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26-8",
    "data-name": "Group 26",
    transform: "translate(2.118 5.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_8",
    "data-name": "SVGCleanerId_0_1_",
    d: "M84.907,210.3a3.312,3.312,0,0,1-.441,1.654,3.365,3.365,0,0,1-.54.7,3.331,3.331,0,0,1-2.359.981H75.3a3.336,3.336,0,0,1-2.359-5.7,3.353,3.353,0,0,1,2.359-.981h6.271A3.35,3.35,0,0,1,84.907,210.3Z",
    transform: "translate(-71.957 -206.964)",
    fill: "#f8d181"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_371-8",
    "data-name": "Path 371",
    d: "M113.591,210.3a2.049,2.049,0,0,1-2.47,2.346H104.85a3.349,3.349,0,0,1-3.34-3.34,2.049,2.049,0,0,1,2.47-2.346h6.271A3.35,3.35,0,0,1,113.591,210.3Z",
    transform: "translate(-98.523 -201.619)",
    fill: "#ffdf9c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_55-8",
    "data-name": "Ellipse 55",
    cx: 0.432,
    cy: 0.432,
    rx: 0.432,
    ry: 0.432,
    transform: "translate(12.434 7.202)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27-8",
    "data-name": "Group 27",
    transform: "translate(5.985 5.346)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16-8",
    "data-name": "Rectangle 16",
    width: 1.466,
    height: 6.68,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17-8",
    "data-name": "Rectangle 17",
    width: 1.465,
    height: 6.68,
    transform: "translate(3.749)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28-8",
    "data-name": "Group 28",
    transform: "translate(5.985 11.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367-8",
    "data-name": "Path 367",
    d: "M204.848,399.575v.993h-1.465v-1.012a3.119,3.119,0,0,0,.342.019Z",
    transform: "translate(-203.383 -399.556)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18-8",
    "data-name": "Rectangle 18",
    width: 1.465,
    height: 0.994,
    transform: "translate(3.749 0.018)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368-8",
    "data-name": "Path 368",
    d: "M223.312,429.868v1.439a.233.233,0,1,1-.466,0v-1.439Z",
    transform: "translate(-222.273 -428.976)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369-8",
    "data-name": "Path 369",
    d: "M345.745,429.868v1.439a.233.233,0,1,1-.466,0v-1.439Z",
    transform: "translate(-341.103 -428.976)",
    fill: "#3f3d56"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(12.863 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 18.677,
    cy: 9.154,
    rx: 18.677,
    ry: 9.154,
    transform: "translate(0 37.173) rotate(-84.369)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M569.252,176.562c-1.488-22.212,4.265-43.629,4.323-43.843l.261.071c-.058.213-5.8,21.589-4.314,43.754Z",
    transform: "translate(-560.242 -126.586)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 9.387,
    height: 0.27,
    transform: "translate(10.771 20.082) rotate(-22.51)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 0.27,
    height: 9.387,
    transform: "matrix(0.556, -0.831, 0.831, 0.556, 2.271, 17.263)",
    fill: "#3f3d56"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontpageStep4);
export default __webpack_public_path__ + "static/media/frontpage_step_4.8a01c893ca130f7385080fb41e32b07c.svg";
export { ForwardRef as ReactComponent };